module.exports = __webpack_public_path__ + "img/icon-2.a79dadc7.png";